import React from 'react'

const Trolley = ({
  className = '',
  width = '1em',
  height = '1em',
  ...props
}) => (
  <svg className={`ac-icon ac-icon__trolley ${className}`} width={width} height={height} {...props} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" d="M20.226 12H7.106L6 6h15.859l-1.633 6zm2.268-8c.48 0 .934.21 1.215.579.282.39.36.965.208 1.421l-1.851 6.9c-.23.698-.802 1.1-1.447 1.1H7.482l.388 2h12.652a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H7.455a1.492 1.492 0 0 1-1.462-1.16L3.199 2h-2.7a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 0h3.944a.5.5 0 0 1 .49.407L5.602 4h16.893zM19 24a2 2 0 1 1 .001-4.001A2 2 0 0 1 19 24zM8 24a2 2 0 1 1 .001-4.001A2 2 0 0 1 8 24z"/>
  </svg>
)

export default Trolley
